import { Component } from '@angular/core';
import { SaleReport } from '../sale-report/sale-report';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-sale',
  imports: [SaleReport,TranslatePipe],
  templateUrl: './sale.html',
  styleUrl: './sale.css',
})
export class Sale {

}
